import { getToken, getUser } from "../../../../Helpers/Utils/Common";
import { getWithParamsAPICall, postAPICallwithFile } from "../axiosMethodCall";

// PhilHealth forms
// export const createPhilhealthForm = async (philhealthForm, patientDetails) => {
//   try {
//     var formData = new FormData();
//     formData.append("requester", getUser());
//     formData.append("token", getToken());
//     formData.append("patient_id", patientDetails.id);
//     formData.append("patient_type", philhealthForm.patient_type);
//     formData.append("member_pin", philhealthForm.member_pin);
//     if (philhealthForm.patient_type === "dependent") {
//       formData.append("dependent_pin", philhealthForm.dependent_pin);
//     } else {
//       formData.append("dependent_pin", null);
//     }
//     formData.append("first_name", philhealthForm.first_name);
//     formData.append("middle_name", philhealthForm.middle_name);
//     formData.append("last_name", philhealthForm.last_name);
//     formData.append("extension_name", philhealthForm.extension_name);
//     formData.append("birthdate", philhealthForm.birthdate);
//     formData.append("mobile_number", philhealthForm.mobile_number);
//     formData.append("enlistment_date", philhealthForm.enlistment_date);
//     formData.append("enlistment_status", philhealthForm.enlistment_status);
//     formData.append("package_type", philhealthForm.package_type);
//     formData.append("atc", philhealthForm.atc);

//     const response = await postAPICallwithFile(
//       process.env.REACT_APP_LINK + "philhealth/create-form",
//       formData
//     )

//     return response;
//   } catch (error) {
//     console.error("Error creating PhilHealth form:", error);
//     return error;
//   }
// }

// export const getPhilHealthFormById = async (philhealthFormId) => {
//   try {
//     const response = await getWithParamsAPICall(
//       process.env.REACT_APP_LINK + "philhealth/get-form",
//       {
//         requester: getUser(),
//         token: getToken(),
//         philhealth_form_id: philhealthFormId
//       }
//     );

//     return { data: response.data };
//   } catch (error) {
//     console.error("Error fetching PhilHealth form by ID:", error);
//     return { error: error.response };
//   }
// }

// PhilHealth Konsulta reports
export const createKonsultaReport = async (patientData, outpatientData) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("philhealth_data", JSON.stringify(patientData));
    formData.append("outpatient_data", JSON.stringify(outpatientData));

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "philhealth/create-report",
      formData,
      true
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const updateKonsultaReportById = async (reportId) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("philhealth_report_id", reportId);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "philhealth/update-report",
      formData,
      true
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getKonsultaReportsById = async (patientId) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "philhealth/get-report",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patientId,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getNcdAnswers = async (patientId, answers) => {
  try {
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "philhealth_reports/save_ncd_answers",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patientId,
        ...answers,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response ?? error };
  }
};

export const getNcdAnswersByPatientId = async (patientId) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "philhealth_reports/get_ncd_answers",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patientId,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { error: error?.response };
  }
};

export const checkPhilhealthIsRegistered = async (phic_pin, membership_type) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("phic_pin", phic_pin);
    formData.append("phic_membership_type", membership_type);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "philhealth_reports/is_registered",
      formData,
      true
    );

    return response;
  } catch (error) {
    return { error: error?.response };
  }
};


export const checkPxIsPhilClinicRegistered = async (phic_pin, membership_type) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("phic_pin", phic_pin);
    formData.append("phic_membership_type", membership_type);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "patients/is_registered",
      formData,
      true
    );

    return response;
  } catch (error) {
    return { error: error?.response };
  }
};


export const getPhilhealthRegistrationByPin = async (phic_pin, membership_type, patient_id) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "philhealth_reports/get_registration_by_pin",
      {
        requester: getUser(),
        token: getToken(),
        phic_pin: phic_pin,
        phic_membership_type: membership_type,
        patient_id: patient_id || "",
      }
    );

    return response;
  } catch (error) {
    return { error: error?.response };
  }
};
// Commented out as per client request - ATC is not needed for now
// export const checkPhilhealthATC = async (atc) => {
//   try {
//     var formData = new FormData();
//     formData.append("requester", getUser());
//     formData.append("token", getToken());
//     formData.append("atc", atc);

//     const response = await postAPICallwithFile(
//       process.env.REACT_APP_LINK + "philhealth_reports/is_atc_valid",
//       formData,
//       true
//     );

//     return response;
//   } catch (error) {
//     return { error: error?.response };
//   }
// };
